/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRevenueCodeMulticompany.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/revenue-code-multicompany";

export class AutogenModelRevenueCodeMulticompany<RowType extends ModelRow> extends Endpoint<RowType, RowRevenueCodeMulticompanyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRevenueCodeMulticompany extends ModelRow<RowRevenueCodeMulticompanyFields> {
	constructor(values?: Partial<RowRevenueCodeMulticompanyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRevenueCodeMulticompanyFields {
	company_id: string;
	descr: string;
	expense_glid: string;
	id: string;
	order_mode: string;
	revenue_glid: string;
}

